import type { FileCategory } from '../core/types';

export type WorkbenchView = 'workbench' | 'history';
export type CategoryFilter = FileCategory | 'all';

const TAB_ORDER: Array<{ id: CategoryFilter; label: string }> = [
  { id: 'all', label: '全部' },
  { id: 'image', label: '图片' },
  { id: 'document', label: '文档' },
  { id: 'model', label: '3D' },
  { id: 'other', label: '其他' },
];

export interface HeaderProps {
  view: WorkbenchView;
  category: CategoryFilter;
  availableCategories: FileCategory[];
  onCategory: (category: CategoryFilter) => void;
  onView: (view: WorkbenchView) => void;
  onAccount: () => void;
  authenticated: boolean;
  totalPoints: number | null;
  displayName: string | null;
}

export function Header(props: HeaderProps) {
  const pointsLabel = props.authenticated ? `${props.totalPoints ?? '—'} 积分` : '未登录';

  return (
    <header className="header">
      <div className="shell">
        <button type="button" className="brand" onClick={() => props.onView('workbench')} title="回到工作台">
          <span className="logo">YO</span>
          <span className="name">YOGO</span>
          <span className="sub">/ CONVERT</span>
        </button>

        <nav className="tabs" aria-label="文件分类">
          {TAB_ORDER.map((tab) => {
            const hasEngine = tab.id === 'all' || props.availableCategories.includes(tab.id);
            return (
              <button
                type="button"
                key={tab.id}
                className="tab"
                data-active={props.category === tab.id}
                data-unavailable={!hasEngine}
                title={hasEngine ? undefined : '该分类暂未开放'}
                onClick={() => {
                  props.onCategory(tab.id);
                  props.onView('workbench');
                }}
              >
                {tab.label}
              </button>
            );
          })}
        </nav>

        <span className="spacer" />

        <span className="privacy-pill">
          <span className="dot" />
          本地处理 · 不上传
        </span>

        <button type="button" className="btn btn-ghost" onClick={() => props.onView('history')} aria-pressed={props.view === 'history'}>
          转换记录
        </button>

        <button type="button" className="btn" onClick={props.onAccount}>
          {props.authenticated && props.displayName ? (
            <span className="row" style={{ gap: 8 }}>
              <span className="avatar">{props.displayName.slice(0, 1).toUpperCase()}</span>
              <span>{pointsLabel}</span>
            </span>
          ) : (
            <span>登录 YoGoAccount</span>
          )}
        </button>
      </div>
    </header>
  );
}
